import React from 'react'
import { Customer } from '../../../../../modules/API/Seller/models/tableData'
import SellerHeadCell from './grid/SellerHeadCell'
import { FROZEN_COL0_WIDTH } from './grid/constants'

type Props = {
  list: Customer[]
}

const SellerHead = ({ list }: Props) => {
  return (
    <thead>
      <tr>
        {list.map((item, index) => (
          <SellerHeadCell
            key={index}
            sticky={index <= 1}
            offset={index === 1 ? FROZEN_COL0_WIDTH : 0}
            lastFrozen={index === 1}
            highlight={index < 3}
            width={index === 0 ? `${FROZEN_COL0_WIDTH}px` : '100px'}
          >
            {item.Customer_Name.trim()}
          </SellerHeadCell>
        ))}
      </tr>
    </thead>
  )
}

export default SellerHead
